// extracted by mini-css-extract-plugin
export default {"installGuide":"InstallGuide_installGuide__48Prq","center":"InstallGuide_center__n4WwT"};